// ── サービス停止フラグ ──────────────────────────────────────────
const SERVICE_DISABLED = false;

function ServiceDisabled() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0f172a',
      color: '#e2e8f0',
      fontFamily: 'sans-serif',
      textAlign: 'center',
      padding: '2rem',
    }}>
      <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔧</div>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '0.75rem' }}>
        このサービスは現在ご利用いただけません
      </h1>
      <p style={{ color: '#94a3b8', fontSize: '0.95rem' }}>
        This service is currently unavailable.
      </p>
    </div>
  );
}

import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import OperatorPage from './pages/OperatorPage';
import CaptionPage from './pages/CaptionPage';
import SetupPage from './pages/SetupPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import QRPage from './pages/QRPage';
import AdminPage from './pages/AdminPage';
import { useEventStore } from './stores/eventStore';
import { useEffect, useState } from 'react';

// アクティブイベントがなければ /setup にリダイレクト
// ただし Stripe 決済後（checkout_session_id あり）はスキップ
function RequireEvent({ children }: { children: React.ReactNode }) {
  const { activeEventId, load } = useEventStore();
  const location = useLocation();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    load();
    setLoaded(true);
  }, []);

  // Stripe 決済後または /payment/success からの遷移を許可
  const hasCheckout =
    new URLSearchParams(location.search).has('checkout_session_id') ||
    new URLSearchParams(location.search).get('from') === 'payment' ||
    !!sessionStorage.getItem('andiamo_checkout_session_id');

  // ロード完了前は何も表示しない（誤リダイレクト防止）
  if (!loaded) return null;
  if (!hasCheckout && activeEventId === null) return <Navigate to="/setup" replace />;
  return <>{children}</>;
}

export default function App() {
  if (SERVICE_DISABLED) return <ServiceDisabled />;
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/setup" element={<SetupPage />} />
        <Route path="/payment/success" element={<PaymentSuccessPage />} />
        <Route path="/operator" element={
          <RequireEvent><OperatorPage /></RequireEvent>
        } />
        <Route path="/caption" element={<CaptionPage />} />
        <Route path="/qr" element={<QRPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/" element={<Navigate to="/setup" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
